module.exports = __webpack_public_path__ + "img/consultoria_16-9_640.78f795f7.jpg";